import classNames from 'classnames';
import React, { useLayoutEffect, useRef } from 'react';

import { ArrowAngleLeft, Cross } from '@zooplus/icons';

import { Translations } from '../../types';

import styles from './BurgerNavigation.module.scss';
import { ROOT_PATH } from './BurgerNavigationConverter';
import { PanelData } from './types';

interface BurgerHeaderProps {
    currentPanel: PanelData;
    onClickPrevPanel: (id: string) => void;
    translations: Translations;
    onCloseClick: () => void;
    isOpen?: boolean;
}

const BurgerHeader = ({
    currentPanel,
    onClickPrevPanel,
    translations,
    onCloseClick,
    isOpen,
}: BurgerHeaderProps): JSX.Element => {
    const allCategoriesTitle =
        translations.get('shop.header.burger.navigation.all.products') ?? '';
    const { currentPath, currentTitle = allCategoriesTitle } = currentPanel;
    const showPrevButton = currentPath !== ROOT_PATH;
    const prevLabel = translations.get('general.button.previous');
    const closeLabel = translations.get('general.button.close');
    const backBtnRef = useRef<HTMLButtonElement>(null);
    const closeBtnRef = useRef<HTMLButtonElement>(null);
    const handleFocusFlow = () => {
        if (backBtnRef.current && !backBtnRef.current.disabled) {
            backBtnRef.current.focus();
        } else if (closeBtnRef.current && !closeBtnRef.current.disabled) {
            closeBtnRef.current.focus();
        }
    };
    useLayoutEffect(() => {
        isOpen && handleFocusFlow();
    }, [currentPanel, isOpen]);

    return (
        <header className={styles.burgerHeaderWrapper}>
            <button
                ref={backBtnRef}
                className={classNames(styles.burgerHeaderPrevPanelBtn, {
                    [styles.burgerHeaderPrevPanelBtnHidden]: !showPrevButton,
                })}
                data-zta="burger-header-prev-btn"
                type="button"
                aria-label={prevLabel}
                disabled={!showPrevButton}
                onClick={() => onClickPrevPanel(currentPath)}>
                <ArrowAngleLeft
                    aria-label={prevLabel}
                    data-zta="burger-prev-icon"
                    className={styles.burgerPrevButton}
                />
            </button>
            <p
                data-zta="burger-header-main-link"
                className={styles.burgerHeaderMainLink}>
                {currentTitle}
            </p>
            <button
                ref={closeBtnRef}
                className={styles.burgerHeaderCloseBtn}
                data-zta="burger-header-close-btn"
                type="button"
                aria-label={closeLabel}
                onClick={onCloseClick}>
                <Cross
                    aria-label={closeLabel}
                    data-zta="burger-close-icon"
                    className={styles.burgerCloseButton}
                />
            </button>
        </header>
    );
};

export default BurgerHeader;
